"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const mui_1 = require("tss-react/mui");
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const Close_1 = __importDefault(require("@mui/icons-material/Close"));
const QButton_1 = __importDefault(require("components/QButton"));
const QIconButton_1 = __importDefault(require("components/QIconButton"));
const styles_1 = require("./styles");
const REFRESH_INTERVAL = 250;
const REFRESH_INTERVAL_SMALL = 100;
const useStyle = (0, mui_1.makeStyles)()(styles_1.styles);
const QCard = ({ open: initialOpen, initialCard, cards, onClose, name, children, }) => {
    const [open, setOpen] = (0, react_1.useState)(initialOpen);
    const [qCardCoords, setQCardCoords] = (0, react_1.useState)({});
    const [activeElement, setActiveElement] = (0, react_1.useState)(null);
    const [currentCard, setCurrentCard] = (0, react_1.useState)(initialCard);
    const intervalTimer = (0, react_1.useRef)(null);
    const intervalTimeout = (0, react_1.useRef)(REFRESH_INTERVAL);
    const positionCheck = (0, react_1.useRef)(null);
    const { classes } = useStyle();
    const calcCoords = (edge, qCard, coords) => {
        const pointerSize = styles_1.POINTER_SIZE;
        let { left, top } = coords;
        // we try to place the qCard at it's preferred location
        switch (edge) {
            case 'left':
                left = coords.left - qCard.width - 8;
                top = coords.top + ((coords.bottom - coords.top) / 2 - qCard.height / 2);
                break;
            case 'right':
                left = coords.right + 8;
                top = coords.top + ((coords.bottom - coords.top) / 2 - qCard.height / 2);
                break;
            case 'righttop':
                left = coords.right + 8;
                top = coords.top;
                break;
            case 'rightbottom':
                left = coords.right + 8;
                top = coords.bottom - qCard.height + pointerSize * 1.5;
                break;
            case 'lefttop':
                left = coords.left - qCard.width - 8;
                top = coords.top;
                break;
            case 'leftbottom':
                left = coords.left - qCard.width - 8;
                top = coords.bottom - qCard.height + pointerSize * 1.5;
                break;
            case 'top':
                break;
            case 'bottom':
                break;
            default:
                break;
        }
        if (qCard.nudge) {
            left += qCard.nudge.left || 0;
            top += qCard.nudge.top || 0;
        }
        // don't let the QCard go off the left edge of the screen
        if (left < 0)
            left = 0;
        // Avoid the Qcard to go off the screen
        const maxTopAllowed = window.innerHeight - qCard.height;
        if (top < 0) {
            top = 0;
        }
        else if (top > maxTopAllowed) {
            top = maxTopAllowed;
        }
        return { left, top, right: left + qCard.width, bottom: top + qCard.height };
    };
    const getQCardCoords = (el, qCard) => {
        if (!qCard)
            return null;
        let edge = qCard.edge || 'left';
        if (el) {
            const coords = el.getBoundingClientRect();
            let coordsObj = calcCoords(edge, qCard, coords);
            if (coordsObj.left < 0) {
                edge = edge.replace('left', 'right');
                coordsObj = calcCoords(edge, qCard, coords);
            }
            else if (coordsObj.right > window.innerWidth) {
                edge = edge.replace('right', 'left');
                coordsObj = calcCoords(edge, qCard, coords);
            }
            return Object.assign(Object.assign(Object.assign({}, coords), coordsObj), { edge });
        }
        return null;
    };
    const updateQCardCoords = (el = activeElement) => {
        if (cards) {
            const qCard = cards[currentCard];
            const newCoords = getQCardCoords(el, qCard);
            if ((qCardCoords === null || qCardCoords === void 0 ? void 0 : qCardCoords.top) !== (newCoords === null || newCoords === void 0 ? void 0 : newCoords.top) || (qCardCoords === null || qCardCoords === void 0 ? void 0 : qCardCoords.left) !== (newCoords === null || newCoords === void 0 ? void 0 : newCoords.left)) {
                setQCardCoords(newCoords);
            }
        }
    };
    (0, react_1.useEffect)(() => {
        positionCheck.current = setInterval(() => {
            updateQCardCoords();
        }, REFRESH_INTERVAL);
        return () => {
            if (positionCheck.current) {
                clearInterval(positionCheck.current);
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentCard]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const checkCardPosition = () => {
        updateQCardCoords();
    };
    const updateActiveElement = (el) => {
        if (activeElement) {
            activeElement.classList.remove(classes.highlight);
        }
        if (el) {
            el.classList.add(classes.highlight);
        }
        setActiveElement(el);
        updateQCardCoords(el);
    };
    const checkCardUpdate = (0, react_1.useCallback)(() => {
        if (cards) {
            const qCard = cards[currentCard];
            if (qCard && open) {
                const activeEle = document.getElementById(qCard.elementId);
                if (activeEle !== activeElement) {
                    updateActiveElement(activeEle);
                    if (!activeEle && qCard.next) {
                        setCurrentCard(qCard.next);
                    }
                    else if (!qCard.next) {
                        if (onClose) {
                            onClose();
                        }
                    }
                }
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [cards, currentCard, open, onClose]);
    (0, react_1.useEffect)(() => {
        if (open && cards) {
            checkCardPosition();
        }
    }, [open, cards, checkCardPosition]);
    (0, react_1.useEffect)(() => {
        if (cards) {
            setTimeout(checkCardUpdate, 10);
        }
    }, [cards, checkCardUpdate]);
    (0, react_1.useEffect)(() => {
        if (initialOpen !== open) {
            if (!initialOpen && intervalTimer.current) {
                clearInterval(intervalTimer.current);
            }
            if (initialOpen && !intervalTimer.current) {
                intervalTimer.current = setInterval(checkCardPosition, intervalTimeout.current);
            }
            if (initialOpen) {
                setCurrentCard(initialCard);
            }
            if (!initialOpen && activeElement) {
                activeElement.classList.remove(classes.highlight);
                setActiveElement(null);
            }
            setOpen(initialOpen);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [initialOpen, initialCard, cards, activeElement, classes.highlight, checkCardPosition]);
    const moveCard = (direction, qCard) => {
        const nextCard = qCard[direction];
        if (nextCard) {
            const nextCardData = cards[nextCard];
            const activeEle = document.getElementById(nextCardData.elementId);
            if (nextCardData === null || nextCardData === void 0 ? void 0 : nextCardData.scrollIntoView) {
                updateActiveElement(activeEle);
                intervalTimeout.current = REFRESH_INTERVAL_SMALL;
                activeEle === null || activeEle === void 0 ? void 0 : activeEle.scrollIntoView({ block: 'end', inline: 'nearest', behavior: 'auto' });
                updateQCardCoords(activeEle);
                return;
            }
            updateActiveElement(activeEle);
            setCurrentCard(nextCard);
        }
    };
    const closeClick = () => {
        if (activeElement) {
            activeElement.classList.remove(classes.highlight);
        }
        if (onClose) {
            onClose();
        }
    };
    const qCard = cards === null || cards === void 0 ? void 0 : cards[currentCard];
    const showQCard = Boolean(open && Object.keys(qCardCoords !== null && qCardCoords !== void 0 ? qCardCoords : {}).length && qCard);
    return (<div id={`QCard-Wrapper-${name || 'default'}-${showQCard ? 'showCard' : 'off'}`} className={(0, classnames_1.default)({ [classes.wrapperOff]: !showQCard })}>
      {showQCard && (<div key="qcard-template" className={(0, classnames_1.default)(classes.qcard, qCardCoords === null || qCardCoords === void 0 ? void 0 : qCardCoords.edge)} style={{
                left: qCardCoords === null || qCardCoords === void 0 ? void 0 : qCardCoords.left,
                top: qCardCoords === null || qCardCoords === void 0 ? void 0 : qCardCoords.top,
                width: qCard === null || qCard === void 0 ? void 0 : qCard.width,
                height: qCard === null || qCard === void 0 ? void 0 : qCard.height,
            }}>
          {onClose && typeof onClose === 'function' && (<div className={classes.closeBox}>
              <QIconButton_1.default size="small-target" onClick={closeClick}>
                <Close_1.default className={classes.closeIcon} id="qcard-closex"/>
              </QIconButton_1.default>
            </div>)}
          <div className={classes.contentArea}>
            <Typography_1.default variant="h6" className={classes.title}>
              {qCard === null || qCard === void 0 ? void 0 : qCard.title}
            </Typography_1.default>
            <Typography_1.default variant="body1" className={classes.content}>
              {qCard === null || qCard === void 0 ? void 0 : qCard.content}
            </Typography_1.default>
          </div>
          <div className={classes.buttonArea}>
            {(qCard === null || qCard === void 0 ? void 0 : qCard.prev) && (<QButton_1.default onClick={() => moveCard('prev', qCard)} className={classes.buttonText}>
                {'< Prev'}
              </QButton_1.default>)}
            {(qCard === null || qCard === void 0 ? void 0 : qCard.next) && (<QButton_1.default onClick={() => moveCard('next', qCard)} className={classes.buttonText}>
                {'Next >'}
              </QButton_1.default>)}
          </div>
        </div>)}
      {children}
    </div>);
};
exports.default = QCard;
